/**
 * @author Ariel
 * @date 2023-09-25
 * @description 练习受众设置
 */
import React from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';
import { utils_tool, framework_tool,component_tool  } from '@/tool';
import PracticeAuthSelect from "./practiceAuthSelect";

let { Session } = utils_tool;
let { WizContainer } = framework_tool
let {
  WizModal,
} = component_tool;
class PracticeAuth extends WizContainer {
  componentName = 'practiceAuth';

  constructor(props) {
    super(props);
    let pathname = '/online/practice'
    this.pathname = pathname
    this.state = {
      id: props.practiceId,
      initInfo: props.initialValue,
      ruleIds: props.initialValue && props.initialValue['ruleIds'],
      initialValue: {},
      practiceEnableFlag: false,
      resetTime: new Date().getTime()
    }
  }

  _componentDidMount() {
    this.doActions([
      {
        path: 'whitelist/authInfo',
        payload: {
          key: 'authInfoKey',
          apiParams: { bizType:59, bizId: this.state.id }
        }
      },
      {
        path: 'practice/getBaseInfoById',
        payload: {
          key: 'getPracticeInfo',
          apiParams: { id: this.state.id }
        }
      }
    ]);
    const arr = [];
    this.setState({
      data: arr
    });
  }

  propsAndStateOnChange = {
    practiceInfo: this._practiceInfo.bind(this),
    practiceStatusChange: this._practiceStatusChange.bind(this),
    authInfo: this._authInfo.bind(this),
    saveAuthKey: this._saveAuthKey.bind(this),
  };

  _practiceInfo(nextProps, nextState) {
    let { practiceInfo } = nextProps
    if (practiceInfo && practiceInfo['success']) {
      nextState.ruleIds = practiceInfo['data'].ruleIds
      nextState.practiceEnableFlag = true
    } else {
      wizNotice.error(practiceInfo && practiceInfo['msg'] || '获取练习信息失败，请稍后尝试')
    }
    return false
  }

  _practiceStatusChange(nextProps, nextState) {
    let { practiceStatusChange } = nextProps
    if (practiceStatusChange && practiceStatusChange['success']) {
      nextState.practiceEnableFlag = true
      return true
    } else {
      wizNotice.error(practiceStatusChange && practiceStatusChange['msg'] || '练习发布失败，请稍后尝试')
      return false
    }
  }

  _authInfo(nextProps, nextState) {
    let { authInfo } = nextProps
    if (authInfo && authInfo['success']) {
      nextState.initialValue = authInfo['data']
    } else {
      wizNotice.error(authInfo && authInfo['msg'] || '操作失败,请稍后尝试')
    }
    return false
  }

  _saveAuthKey(nextProps, nextState) {
    let { saveAuthKey,replaceClose } = nextProps
    if (saveAuthKey && saveAuthKey['success']) {
      wizNotice.success(saveAuthKey['msg'])
      replaceClose?replaceClose(): this.jumpPage('replace', this.pathname);
      return true
    } else {
      wizNotice.error(saveAuthKey && saveAuthKey['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _render() {
    const { initialValue, ruleIds,practiceEnableFlag } = this.state
    const { practiceLoading, prevFunc } = this.props
    const selectProps = {
      loading: practiceLoading,
      prevFunc: prevFunc,
      this: this,
      id: this.state.id,
      initialValue: initialValue,
      submit: (value, flag) => {
        if (flag) {
          if (ruleIds && ruleIds.length) {
            this.doAction({
              path: 'practice/enable',
              payload: {
                key: "practiceEnable",
                apiParams: { id: this.state.id, status: 1 }
              }
            })
          } else {
            wizNotice.error('该练习还未设计习题，不能发布')
            return false;
          }
        }
        let saveRequest = {}
        if (value['dataAuth']) {
          let dataAuth = value['dataAuth']
          if(value['dataAuth'].groupId && value['dataAuth'].groupId.length) {
            saveRequest['groupId'] = dataAuth['groupId'].map(p => (p.id)).toString();
          }else{
            saveRequest['orgIds'] = dataAuth['orgIds'] && dataAuth['orgIds'].map(p => (p.id))
            saveRequest['positionIds'] = dataAuth['positionIds'] && dataAuth['positionIds'].map(p => (p.id))
            saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'] && dataAuth['positionCategoryIds'].map(p => (p.id))
            saveRequest['personIds'] = dataAuth['personIds'] && dataAuth['personIds'].map(p => (p['id']))
          }
        }
        saveRequest['id'] = this.state.id
        let values = {}
        values.authCmd = saveRequest
        values.bizType = 59
        values.bizId = this.state.id

        if (practiceEnableFlag) {
          this.doAction({
            path: 'whitelist/save',
            payload: {
              key: "practiceSaveAuthKey",
              apiParams: { ...values }
            }
          })
        }
      },
    };
    return <PracticeAuthSelect {...selectProps} />
  }

}

const mapStateToProps = (state, ownProps) => {
  const { practice, whitelist } = state;
  const practiceInfo = modelUtils.getModelEntity(practice, "getPracticeInfo");
  const practiceStatusChange = modelUtils.getModelEntity(practice, "practiceEnable");
  const authInfo = modelUtils.getModelEntity(whitelist, "authInfoKey");
  const saveAuthKey = modelUtils.getModelEntity(whitelist, "practiceSaveAuthKey");
  const load = modelUtils.getLoadingState(state, ['practice','whitelist']);
  return {
    practiceInfo,
    practiceStatusChange,
    authInfo,
    saveAuthKey,
    ...load
  }
};

export default connect(mapStateToProps)(PracticeAuth)
